import { isFilled } from "@prismicio/client";
import { Button } from "@/components";
import Styles from "./SectionCta.module.css";

/**
 * Optional section CTA for the `numbered`, `features` and `pills` variations —
 * SectionHeader's counterpart, rendered after the grid.
 *
 * Gated on both fields: an unset Link field still arrives as a truthy
 * `{ link_type: "Any" }`, so the label alone can't tell us a link exists.
 */
const SectionCta = ({ label, link }) => {
	if (!label || !isFilled.link(link)) return null;

	return (
		<div className={Styles.cta}>
			<Button
				link={link}
				label={label}
			/>
		</div>
	);
};

export default SectionCta;
